import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

import { faHome } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Columns, LoadingModule, PageHeader,
} from '@domain-group/suit-theme'
import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import defaultRequestOptions from '@sections/Admin/packs/Tasks/defaultRequestOptions'

import useCurrentUser from '@hooks/useCurrentUser'
import useTeams from '@hooks/useTeams'

import useGroupedTasks from '../../hooks/useGroupedTasks'

import Statistics from '../Statistics'
import TaskGroup from '../TaskGroup'
import TeamWorkload from '../TeamWorkload'
import TaskTypeCounts from '../TaskTypeCounts'

const selectTeamId = (teamId: number) => {
  const newHash = `#/tasks/teamOverview?team_id=${teamId}`
  window.location.hash = newHash
}

const PageContent = () => {
  const { team_id }: { team_id?: number } = parsePermittedQueryParams(getQueryParamsFromHash(), ['team_id'])

  // useLocation to refresh the window.location. If not used location won't reload if URL changes
  useLocation()

  const { currentUser } = useCurrentUser()

  const teamsPayload = useTeams({
    filters: {
      user_id: currentUser.id,
    },
    performHttpRequests: !!currentUser.id,
    requestOptions: {
      ...defaultRequestOptions.team,
      ...defaultRequestOptions.teamMember,
    },
  })

  const groupedTasksPayload = useGroupedTasks({
    filters: {
      team_id,
    },
    groupKey: 'assignee_id',
    performHttpRequests: true,
    requestOptions: {
      ...defaultRequestOptions.image,
      ...defaultRequestOptions.user,
    },
  })

  const {
    entities, groupedTasks, loading,
  } = groupedTasksPayload

  return (
    <>
      <Helmet>
        <title>Team Overview | Template Manager</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="overview"
        boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
        tabBarItems={[
          {
            href: '#/tasks?sub_tasks=false',
            icon: faHome,
            key: 'overview',
            title: 'Overview',
          },
        ]}
        title="Team Overview"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading} times={3} />

            {/*
             // @ts-expect-error TS2322 */}
            {!loading && <Statistics teamId={team_id} />}

            {!loading && Object.values(groupedTasks).map(taskGroup => (
              <TaskGroup
                // @ts-expect-error TS2322
                assigneeId={taskGroup.assignee_id}
                entities={entities}
                key={taskGroup.assignee_id}
                taskListItems={taskGroup.items}
              />
            ))}
          </Columns.Main>

          <Columns.Sidebar>
            <TeamWorkload
              callbacks={{
                selectTeamId,
              }}
              entities={entities}
              groupedTasks={groupedTasks}
              // @ts-expect-error TS2322
              selectedTeamId={team_id}
              teamsPayload={teamsPayload}
            />

            {/*
             // @ts-expect-error TS2322 */}
            <TaskTypeCounts requestOptions={{ sub_tasks: false, team_id }} />

            {/*
             // @ts-expect-error TS2322 */}
            <TaskTypeCounts requestOptions={{ sub_tasks: true, team_id }} />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
